<template>
    <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
        <div id="open_ticket_container" style="width:100%;height:100%;background-color:white;display:flex;justify-content:center;align-items:center;">
            <v-img v-show="tickets.length < 1" :src="require('../assets/check-mark-circle3.png')" contain height="200"></v-img>
            <dx-data-grid v-show="tickets.length" class="grid" :data-source="tickets" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true" @cellClick="gridClick" @cellPrepared="cellPrepared">
                <dx-column data-field="subject" caption="Subject"/>
            </dx-data-grid>
        </div>
    </v-container>
</template>

<script>
    import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

    export default {
        name: "OpenTickets",
        components: {
            DxDataGrid,
            DxColumn,
            DxPaging,
            DxScrolling
        },
        props: {
            tickets: []
        },
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    }

</script>

<style scoped></style>

<style>
    #open_ticket_container{
        width: calc(100% - 20px) !important;
        max-height: calc(100vh - 213px);
        overflow-y: scroll;
        position: absolute;
        top: 0;
    }

    #open_ticket_container .dx-widget{
        width: 100%;
    }
</style>
